import React from 'react';
import { cn } from '../../utils/cn';
type Tone = 'neutral' | 'primary' | 'accent' | 'action' | 'success' | 'danger';
const tones: Record<Tone, string> = {
  neutral: 'bg-oat text-ink-2',
  primary: 'bg-primary-soft text-primary',
  accent: 'bg-accent-soft text-on-accent dark:text-accent',
  action: 'bg-action-soft text-action',
  success: 'bg-success-soft text-success',
  danger: 'bg-danger-soft text-danger'
};
export function Badge({
  tone = 'neutral',
  className,
  children
}: {
  tone?: Tone;
  className?: string;
  children: React.ReactNode;
}) {
  return <span className={cn('inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.04em]', tones[tone], className)} data-id="element-932" data-mp="lnzf8d16ap3r">
      {children}
    </span>;
}
export function Pill({
  className,
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <span className={cn('inline-flex items-center gap-1.5 rounded-full border border-hairline px-3 py-1 text-xs text-ink-2', className)} data-id="element-933" data-mp="1s3jjd7q1qhb6">
      {children}
    </span>;
}